






































































































import { setCssThemeVars, checkForSavedConfigs } from '@/utils/gamblingHelpers'
import { Action, Mutation } from 'vuex-class'
import { mapState } from 'vuex'
import { Component, Vue, Watch } from 'vue-property-decorator'
import Header from '@/components/gambling/Layout/Header.vue'
import HeaderTwo from '@/components/gambling/Layout/HeaderTwo.vue'
import Footer from '@/components/gambling/Layout/Footer.vue'
import Sidebar from '@/components/gambling/Layout/Sidebar.vue'
import LoginModal from '@/components/gambling/LogInModal.vue'
import QuickDeposits from '@/components/gambling/QuickDeposit.vue'

@Component({
  components: {
    Header,
    HeaderTwo,
    Footer,
    Sidebar,
    LoginModal
  },
  computed: {
    ...mapState({
      choosedTheme: ({ gamblingContext }: any): string => gamblingContext.choosedTheme,
      themeOptionsState: ({ gamblingContext }: any): string[] => gamblingContext.themeOptions,
      firstDeposit: ({ gamblingContext }: any): string[] => gamblingContext.firstDeposit,
      isAuth: ({ gamblingContext }: any): string[] => gamblingContext.isAuthenticated,
      pageLayout: ({ gamblingContext }: any) => gamblingContext.pageLayout,
      logInSuccessMsg: ({ gamblingContext }: any) => gamblingContext.logInSuccessMsg,
      fullName: ({ gamblingContext }: any): null | string => gamblingContext.credentials.username,
      currencyCode: ({ gamblingContext }: any) => gamblingContext.currencyCode,
      depositMessage: ({ gamblingContext }: any) => gamblingContext.depositMessage
    })
  }
})

export default class GamblingPage extends Vue {
  @Action('setSessionUser') private setSessionUser: any
  @Action('setPageTheme') private setPageTheme: any
  @Action('reloadCashier') private reloadCashier: any
  @Action('setCurrency') private setCurrency: any
  @Mutation('setAccountType') private setAccountType: any
  @Mutation('setLogInSuccessMsg') private setLogInSuccessMsg: any
  @Mutation('setDepositMessage') private setDepositMessage: any

  private choosedTheme!: string
  private $routeChange!: any
  private themeOptionsState!: string[]
  private themeModal: boolean = false
  private logInSuccessMsg!: boolean
  private depositMessage!: string
  private pageLayout!: string

  get depositMessageModalGetSet () {
    return this.depositMessage.length > 0
  }
  set depositMessageModalGetSet (val: any) {
    this.setDepositMessage(val)
  }
  get choosedThemeGetSet () {
    return this.choosedTheme
  }
  set choosedThemeGetSet (themeColor: string) {
    this.setPageTheme(themeColor)
  }

  get logInSuccessMsgGetSet (): boolean {
    return this.logInSuccessMsg
  }
  set logInSuccessMsgGetSet (val: boolean) {
    this.setLogInSuccessMsg(val)
  }

  private themeOptions!: string[]
  private showBanner: boolean = true

  @Watch('depositMessageModalGetSet')
  private onDepositMessageModalGetSet (val: any) {
    if (!val) {
      this.depositMessageModalGetSet = ''
    }
  }
  @Watch('choosedThemeGetSet')
  private onChoosedThemeGetSet (val: string, oldVAL: string) {
    this.setPageTheme(val)
  }

  private openThemeModal (): void {
    this.themeModal = true
  }

  private toDepositNow (): void {
    this.setAccountType('banking')
    this.reloadCashier({ method: 'deposit' })
    this.$routeChange('/gambling/account')
  }

  private updateTheme (theme: string): void {
    setCssThemeVars(theme)
  }

  private created () {
    this.setCurrency()
    this.themeOptions = [ ...this.themeOptionsState ]
    if (sessionStorage.__CASHIER_DEMO_SESSION__) {
      const parsed = JSON.parse(sessionStorage.__CASHIER_DEMO_SESSION__)
      const localStorageConfigs: any = checkForSavedConfigs()
      if (localStorageConfigs && localStorageConfigs.demoThemesOptions) {
        if (typeof localStorageConfigs.demoThemesOptions.theme === 'string') {
          parsed.pageTheme = localStorageConfigs.demoThemesOptions.theme
        }
      }
      this.updateTheme(parsed.pageTheme)
      this.setSessionUser(parsed)
    } else {
      setCssThemeVars(this.choosedTheme)
    }
    this.$vuetify.theme.dark = true
  }
}
